module.exports = __webpack_public_path__ + "static/media/ZiXun4.a16aba60.png";